/**
 * Shared marketing layout: same horizontal column as nav/footer (max-w-6xl).
 * Use MARKETING_PROSE inside the outer shell for readable article width.
 */
export const MARKETING_OUTER =
  "mx-auto w-full max-w-6xl px-4 sm:px-6"

export const MARKETING_SECTION_Y = "py-14 sm:py-20"

export const MARKETING_PROSE = "max-w-3xl"

/** The home page. (/home was a copy of it, and redirects here now.) */
export const MARKETING_HOME_PATH = "/" as const
